import dynamic from "next/dynamic";
import PageContextWrapper from "@components/Components/Reusables/PageContextWrapper";
import PageHead from "@components/Components/Reusables/PageHead";

const ContactUs = dynamic(() => import("../js/Components/Contact/ContactUs"));

//Dynamically load the home component and return it

const contactus = ({ data }) => {
    const meta = data.template_page_content.meta;

    return (
        <>
            <PageHead
                title={meta.meta_title}
                description={meta.meta_description}
                ogTitle={meta.og_title}
                ogType={meta.og_type}
                ogUrl={meta.og_url}
                ogImage={meta.og_image}
                ogDescription={meta.og_description}
                ogSiteName={meta.og_site_name}
            />

            <PageContextWrapper
                page='contactus'
                page_content={data.template_page_content}
            >
                <ContactUs {...data} />
            </PageContextWrapper>

        </>
    );
};

export async function getServerSideProps({ query, res }) {

    try {
        const req = await fetch(`${process.env.NEXT_PUBLIC_BASE_API_URL}contact-us`);
        const data = await req.json();

        if (data.exception) {
            return { notFound: true }
        }

        return {
            props: {
                data
            },
        };
    } catch (error) {
        res.statusCode = 404;
        return {
            props: {}
        }
    }

}

// export async function getStaticProps({ query, res }) {

//     try {
//         const req = await fetch(`${process.env.NEXT_PUBLIC_BASE_API_URL}contact-us`);
//         const data = await req.json();

//         if(data.exception) {
//             return {notFound: true}
//         }

//         return {
//             props: {
//                 data
//              },
//         };
//     } catch (error) {
//         res.statusCode = 404;
//         return {
//             props: {}
//         }
//     }

// }

export default contactus;
